<template>
  <div>
    <tk-flex class="font-12" >
      <div class="font-bold unshrink" style="color: #363B45;padding: 9px 5px;" >战区</div>
      <tk-flex v-if="warZoneList.length" wrap>
        <div
          v-for="(item,index) in warZoneList" :key="index"
          class="m-l-8" style="padding: 9px 14px;cursor: pointer;"
          :style="{ 'color': item.objectId === warZone ? '#FF2A58' : '#808690' }"
          @click="warZone = item.objectId"
        >
          {{ item.name }}
        </div>
      </tk-flex>
      <div v-else
        class="m-l-8" style="padding: 9px 14px;color: #808690;"
      >暂无</div>
    </tk-flex>
    <tk-flex class="font-12" >
      <div class="font-bold unshrink" style="color: #363B45;padding: 9px 5px;" >大区</div>
      <tk-flex v-if="regionList.length" wrap>
        <div
          v-for="(item,index) in regionList" :key="index"
          class="m-l-8" style="padding: 9px 14px;cursor: pointer;"
          :style="{ 'color': item.objectId === region ? '#FF2A58' : '#808690' }"
          @click="region = item.objectId"
        >
          {{ item.name }}
        </div>
      </tk-flex>
      <div v-else
        class="m-l-8" style="padding: 9px 14px;color: #808690;"
      >暂无</div>
    </tk-flex>
  </div>
</template>

<script>

export default {
  props: {

  },
  data () {
    return {
      warZoneList: [],
      warZone: '',
      regionList: [],
      region: ''
    }
  },
  computed: {
    _region: {
      get () {
        return this.region
      },
      set (v) {
        // v-model接收input事件的值来更新value
        this.$emit('update:region', v)
      }
    }
  },
  watch: {
    warZone (v) {
      this.regionList = []
      this.region = ''
      this.getRegion()
    },
    region (v) {
      this._region = v
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await this.getWarZone()
    },
    async getWarZone () {
      const { data } = await this.$tkParse.get('/classes/department', {
        params: {
          where: {
            parentNode: {
              $exists: false
            },
            isDelete: {
              $ne: true
            }
          },
          limit: 1000,
          order: '-createdAt'
        }
      })
      if (data.results.length) {
        this.warZoneList = data.results
        this.warZone = data.results[0].objectId
      }
    },
    async getRegion () {
      const { data } = await this.$tkParse.get('/classes/department', {
        params: {
          where: {
            parentNode: this.warZone,
            isDelete: {
              $ne: true
            }
          },
          limit: 1000,
          order: '-createdAt'
        }
      })
      if (data.results.length) {
        this.regionList = data.results
        this.region = data.results[0].objectId
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
